import { hexToRgba } from '../../../common/utils';
import { COLOURS } from '../../../common/styles/vars';


export default {
  option: (
  styles,
  {
    data: { tag: { color } },
    isDisabled,
    isSelected
  }) =>
  {
    const backgroundColor = isSelected ? COLOURS.grey.sterling : 'transparent';
    return {
      ...styles,
      color,
      cursor: isDisabled ? 'not-allowed' : 'default',
      position: 'relative',
      backgroundColor,
      maxWidth: '100%',
      ':active': {
        ...styles[':active'],
        backgroundColor
      },
      ':hover': {
        ':after': {
          content: '""',
          background: COLOURS.cyan.jungleGreen.monkeyLight,
          position: 'absolute',
          left: '10px',
          top: '5px',
          width: 'calc(100% - 20px)',
          height: 'calc(100% - 10px)',
          zIndex: -1,
          borderRadius: '8px'
        }
      }
    };
  },
  multiValue: (styles, { data: { tag: { color } } }) => ({
    ...styles,
    backgroundColor: hexToRgba(color, 0.1)
  }),
  multiValueLabel: (styles, { data: { tag: { color } } }) => ({
    ...styles,
    marginLeft: '8px',
    color
  }),
  multiValueRemove: (styles, { data: { tag: { color } } }) => ({
    ...styles,
    color: hexToRgba(color, 0.1),
    ':hover': {
      backgroundColor: hexToRgba(color, 0.5),
      color: 'white'
    }
  })
};